(function () {
	'use strict';

	/**
	 * @ngdoc directive
	 * @name mx.SolutionBuilderAgent:mxSearchQueryGroup
	 * @module mx.SolutionBuilderAgent
	 * @restrict 'E'
	 * @scope {}
	 * @requires mx.components.Recursion
	 * @requires mx.shell.EventService
	 * @requires {@ref mx.shell.SearchProviderService mx.shell.SearchProviderService}
	 * @description
	 * A group of search conditions. Used to group query conditions on {@ref mx.shell:mxSearchQueryBuilder form} that allows to create or update complex search queries
	 * @param {mx.SolutionBuilderAgent.SearchQueryGroup} group= - {@ref mx.shell.SearchQueryGroup Search query conditions group model}
	 * @param {mx.SolutionBuilderAgent.SearchQueryGroup} parent= - Parent search query conditions group
	 * @param {mx.shell.SearchContext} context= - Reference to a {@ref mx.shell.SearchContext search context model}
	 * related to search query being selected for update
	 * @usage <mx-search-query-group data-context="vm.context" data-group="subGroup" data-parent="vm.group"></mx-search-query-group>
	 */
	angular.module('mx.SolutionBuilderAgent').component('mxConditionGroup', {
		require: {
			builder: '^^mxConditionsBuilder',
			parentGroupContainer: '^^?mxConditionGroup',
		},
		bindings: {
			group: '=',
			parentExpanded: '<',
		},
		controller: MxConditionGroupCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-condition-builder/mx-condition-group.html',
	});

	MxConditionGroupCtrl.$inject = [];

	function MxConditionGroupCtrl() {
		var vm = this;

		vm.$onInit = function () {
			Object.defineProperty(vm, 'conditionsBuilder', {
				get: function () {
					return vm.builder.conditionsBuilder;
				},
			});
		};
	}
})();
